@use "variables" as *;

.impactStack {
  align-items: center;
}
